// Dải hỏi (UI_SPEC §4.3): một câu + đúng 2 nút; THÔI (ghost) bên trái, nút làm bên phải.
import type { JSX } from 'preact';
import { t } from '@i18n/t';
import { ask, resolveAsk } from '@state/modules/ui';
import { TextButton } from '../kit/TextButton';
import { HoldButton } from '../kit/HoldButton';

export function AskStripHost(): JSX.Element | null {
  const a = ask.value;
  if (!a) return null;
  return (
    <div class="ht-ask-layer">
      <div class="ht-scrim" data-id="ask-scrim" onClick={() => resolveAsk(false)} />
      <section
        class="ht-ask"
        role="dialog"
        aria-modal="true"
        aria-label={t(a.textKey, a.textParams)}
        data-id="ask"
      >
        <p>{t(a.textKey, a.textParams)}</p>
        <div class="ht-actions">
          <TextButton variant="ghost" id="ask-cancel" onClick={() => resolveAsk(false)}>
            {t('ui.cancel')}
          </TextButton>
          {a.hold ? (
            <HoldButton id="ask-confirm" hint={t('ui.hold.hint')} onHold={() => resolveAsk(true)}>
              {t(a.confirmKey)}
            </HoldButton>
          ) : (
            <TextButton id="ask-confirm" onClick={() => resolveAsk(true)}>
              {t(a.confirmKey)}
            </TextButton>
          )}
        </div>
      </section>
    </div>
  );
}
